/*
 * checks if 'value' is an object as per a custom opinionated definition
 */

module.exports = function isObject (value) {
  return (
    value
    && typeof value === 'object'
    && value.constructor === Object
  )
}
